/**
 * Range PLP quick-filter chips (KINDW-103 / FSD PLP-07).
 * Figma: KL-Designs — Filters container 3132:3849, Pill button 3132:3851, mobile wrap 3132:6700.
 */
const RangeFilterTags = {
  parts: ['wrapper', 'scrollTrack', 'scroll', 'chipItem', 'chip', 'chipLabel', 'chipCount'],
  baseStyle: {
    wrapper: {
      className: 'range-filter-tags',
      marginBottom: {base: 6, lg: 8},
      maxW: '100%',
      paddingX: {base: '20px', lg: 'unset'},
      width: '100%',
    },
    scrollTrack: {
      marginX: {base: '-20px', lg: 0},
      maxW: {base: 'calc(100% + 40px)', lg: '100%'},
      overflow: 'hidden',
      width: {base: 'calc(100% + 40px)', lg: '100%'},
    },
    scroll: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: {base: 1.5, lg: 3},
      overflowX: 'auto',
      overflowY: 'hidden',
      overscrollBehaviorX: 'contain',
      px: {base: '20px', lg: 0},
      touchAction: 'pan-x',
      WebkitOverflowScrolling: 'touch',
      width: '100%',
    },
    chipItem: {
      flexShrink: 0,
    },
    chip: {
      alignItems: 'center',
      borderRadius: '100px',
      border: '1px solid',
      borderColor: 'brandColors.linen03',
      bg: 'transparent',
      color: 'brandColors.greyscale90',
      display: 'inline-flex',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      gap: 2,
      justifyContent: 'center',
      lineHeight: '120%',
      h: 'auto',
      H: '35px',
      minW: 'unset',
      px: 4,
      py: 2,
      transition: 'background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease',
      whiteSpace: 'nowrap',
      sx: {
        height: '35px',
        '& > *': {
          fontSize: 'md',
          fontStyle: 'normal',
          fontWeight: '400',
        },
      },
      _hover: {
        bg: 'brandColors.greyscale90',
        borderColor: 'brandColors.greyscale90',
        color: 'white',
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
      },
      '&[aria-pressed="true"]': {
        bg: 'brandColors.greyscale90',
        borderColor: 'brandColors.greyscale90',
        color: 'white',
        fontWeight: '400',
        _hover: {
          bg: 'brandColors.greyscale90',
          borderColor: 'brandColors.greyscale90',
          color: 'white',
        },
      },
    },
    chipLabel: {
      display: 'inline',
    },
    chipCount: {
      display: 'inline',
      flexShrink: 0,
      fontWeight: '400',
      marginLeft: 0,
      opacity: 0.7,
    },
  },
  variants: {
    default: {},
  },
  defaultProps: {
    variant: 'default',
  },
};

export default RangeFilterTags;
